var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-copy",attrs:{"type":"button","title":_vm.title,"disabled":_vm.disabled || !_vm.text},on:{"click":function($event){$event.stopPropagation();return _vm.copyText.apply(null, arguments)}}},[_c('span',{staticClass:"material-icons ui-copy__icon"},[_vm._v("content_copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }